import React from 'react';
import { Helmet } from "react-helmet";

// Edit these arrays to update the gear list.
const gearCategories = [
  {
    title: 'Cameras',
    items: [
      'Camera body 1',
      'Camera body 2',
    ],
  },
  {
    title: 'Lenses',
    items: [
      'Lens 1',
      'Lens 2',
      'Lens 3',
    ],
  },
  {
    title: 'Lighting',
    items: [
      'Strobe / flash',
      'Modifiers',
    ],
  },
  {
    title: 'Accessories',
    items: [
      'Tripod',
      'Memory cards',
      'Bags',
    ],
  },
];

const GearList = () => {
  return (
    <>
      <Helmet>
        <title>Sope Adelaja | Gear List</title>
        <meta name="description" content="The cameras, lenses, lighting and accessories used by Sope Adelaja." />
      </Helmet>

      <div className="bg-[#252525] w-full min-h-screen xl:px-[15em] lg:px-10 md:px-10 px-4 py-12">
        <div className="border-b border-[#484540] py-4 mb-10">
          <h1 className="font-navbar uppercase text-2xl text-[#e7ddd3] tracking-[.15em]">
            gear list
          </h1>
        </div>

        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          {gearCategories.map((category) => (
            <div key={category.title}>
              <div className="border-b border-[#484540] py-3 mb-4">
                <h2 className="font-navbar uppercase text-xl text-[#e7ddd3] tracking-[.15em]">
                  {category.title}
                </h2>
              </div>
              <ul className="space-y-2">
                {category.items.map((item, index) => (
                  <li key={index} className="text-[#b7a78b] text-[15px]">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default GearList;
